import { useState } from "react";
import { Link2, Plus, X, ExternalLink } from "lucide-react";
import { logWarn } from "../../lib/logger";

export default function LinksSection({ task, patch }) {
  const [url, setUrl] = useState("");
  const links = task.links || [];

  const save = (next) => patch({ links: next });
  const remove = (id) => save(links.filter((l) => l.id !== id));

  const add = () => {
    let u = url.trim();
    if (!u) return;
    if (!/^https?:\/\//i.test(u)) u = `https://${u}`;
    let title = u;
    try {
      title = new URL(u).hostname.replace(/^www\./, "");
    } catch (parseErr) {
      logWarn("Could not parse URL, using raw value as title:", parseErr);
    }
    save([...links, { id: crypto.randomUUID(), url: u, title }]);
    setUrl("");
  };

  return (
    <div className="p-4 border-b border-border" data-testid="panel-links">
      <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-2">Link references{links.length > 0 && ` · ${links.length}`}</p>
      <div className="space-y-1">
        {links.map((l) => (
          <div key={l.id} data-testid={`link-item-${l.id}`} className="flex items-center gap-2 p-1.5 rounded-md border border-border group">
            <Link2 size={14} className="text-[#1B2A6B] dark:text-blue-300 shrink-0" />
            <a data-testid={`link-open-${l.id}`} href={l.url} target="_blank" rel="noreferrer" className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate hover:text-[#E31E24] transition-colors">{l.title}</p>
              <p className="text-[10px] text-muted-foreground truncate">{l.url}</p>
            </a>
            <ExternalLink size={12} className="text-muted-foreground shrink-0" />
            <button data-testid={`link-delete-${l.id}`} onClick={() => remove(l.id)}
              className="h-5 w-5 hidden group-hover:flex items-center justify-center rounded text-muted-foreground hover:text-[#E31E24] transition-colors shrink-0">
              <X size={12} />
            </button>
          </div>
        ))}
        {links.length === 0 && <p className="text-xs text-muted-foreground">No links attached. Paste a URL below (drawings, docs, references).</p>}
      </div>
      <div className="flex items-center gap-2 mt-2">
        <Plus size={14} className="text-muted-foreground shrink-0" />
        <input data-testid="link-add-input" value={url} onChange={(e) => setUrl(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Paste a link, press Enter"
          className="flex-1 h-7 px-2 text-sm rounded border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
        <button data-testid="link-add-button" onClick={add}
          className="h-7 px-2.5 text-xs font-medium rounded-md bg-[#E31E24]/10 text-[#E31E24] hover:bg-[#E31E24]/20 transition-colors shrink-0">
          Add
        </button>
      </div>
    </div>
  );
}
